/**
 * User: Rob Richard
 * Date: 9/11/14
 * Time: 4:21 PM
 */

'use strict';

var _ = require('underscore');
var $ = require('dibs-jquery-shim');

var poster = module.exports = {
    _submit: function ($form) { // for easy testing
        // Firefox requires the element to be
        // in the DOM to submit it
        $form.attr('style', 'display:none');
        $('body').append($form);
        $form.submit();
    },
    setUpForm: function (url, data) {
        var $form = $('<form method="post"></form>');
        $form.attr('action', url);
        _.each(data, function (value, name) {
            var $input = $('<input>');
            $input.attr('name', name);
            $input.val(value);
            $form.append($input);
        });

        return $form;
    },
    /**
     * Posts the entire page to another url
     * @param url
     * @param data - object to convert to post data
     */
    post: function (url, data) {
        var $form = poster.setUpForm(url, data);
        poster._submit($form);
    },
    postToIframe: function (url, data) {
        var target = _.uniqueId('postToIframe');
        var $form = poster.setUpForm(url, data);
        var $iframe = $('<iframe>');
        var dfd = new $.Deferred();

        $form.attr({ target: target, style: 'display:none' });
        $iframe.attr({ name: target, style: 'display:none' });
        $('body').append($form);
        $('body').append($iframe);
        $iframe.on('load', function() {
            var response = $iframe.contents().find('body').html();
            $form.remove();
            $iframe.remove();
            dfd.resolve(response);
        });
        $form.submit();
        return dfd.promise();
    }

};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/poster.js
// module id = 1981
// module chunks = 64